import axios from 'axios'

export default function request(config){
  const instance = axios.create({
    // baseURL:'https://opendev.zctech.xyz:6595',
    // baseURL:'http://192.168.1.173:9000',
    baseURL:'/apis',
    timeout:20000
  })
  instance.interceptors.request.use(config=>{
    return config
  },err=>err)
  instance.interceptors.response.use(res=>{
    return res.data
  },err=>err)
  return instance(config)
}